
import mPaneV2 from '@/components/lots/VirtualPanelV2/index.vue';
import config from './config';
import paper from '@/components/core/paper/Paper';
import { getAiRecordInfos,aiRecordInfosCount} from './api';
import dayjs from 'dayjs';
import reportExport from '@/components/lots/reportExportPlugin';
import { mapState } from 'vuex';
import bigDataLog from '@/utils/bigDataLog';
import { isInMonth } from '@otp/utils/commonFun';
export default {
    name: 'aiSearch',
    components: { mPaneV2, paper, reportExport},
    data() {
        return {
            config: config,
            loading: false,
            optionNum: '',
            totalData: [],
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            visible: false,
            dialog: config.dialog,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            selectedRows: [],
            aginNodeData: {},
            batchWriteOffVisible: false,
            batchWriteOffForm: {
                transId: ''
            },
            btnLoading: false,
            exportParams:{},
        };
    },
    methods: {
        changeDateFormat(arr) {
            arr = arr || [];
            arr.forEach((item, index) => {
                arr[index] = dayjs(item).format('YYYY-MM-DD HH:mm:ss');
            });
            return arr;
        },
        getList(toFirstPage) {
            if (toFirstPage) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
                return;
            }
            const params = Object.assign({}, this.searchParams);
            const msg = this.searchLimit(params);
            if (msg) {
                this.$message.warning(msg);
                return;
            }
            this.deleteNullSearchParams(params,['batchQueryKey','batchQueryValue','siteName','importTime','companyName']);
            this.loading = true;
            this.exportParams={...params}
            getAiRecordInfos(params).then(res => {
                if (res && res.code === '0') {
                    this.totalData =res.data.list
                    // this.pageTotal = res.data.totalCount;
                    this.getPageTotal(params)
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        async getPageTotal(searchParams) {
            const isInMonthRes = isInMonth(searchParams.importTimeStart, searchParams.importTimeEnd);
            if (!isInMonthRes) {
                this.pageTotal = this.ORDER_DATA_DICT.PAGE_TOTAL;
                return;
            }
            const totalCountRes = await aiRecordInfosCount(searchParams);
            this.pageTotal = totalCountRes ? totalCountRes.data : this.ORDER_DATA_DICT.PAGE_TOTAL;
        },
        searchLimit(data) {
            const isBatch = data.batchQueryValue && data.batchQueryKey;
            data.importTime = this.changeDateFormat(data.importTime);
            const [importTimeStart, importTimeEnd] = data.importTime;
            if (!data.importTime && data.batchQueryKey === 'customerOrderNo' && !data.batchQueryValue) {
                return '客户订单号 或 时间不可为空！';
            }
            if(dayjs(importTimeEnd).diff(dayjs(importTimeStart), 'd') > 31){
                return '最多查询一个月的数据'
            }
            data.importTimeStart=importTimeStart
            data.importTimeEnd=importTimeEnd
            if (isBatch) {
                data.batchQueryValue = data.batchQueryValue && data.batchQueryValue.split(',');
                const userQueryCount = data.batchQueryValue && data.batchQueryValue.length;
                if (userQueryCount > 100) {
                    return `一次最多查询100个订单号`;
                }
            } else {
                data.batchQueryValue = [];
            }
            if(data.orderStatusList && data.orderStatusList.length>0)data.orderStatusList =data.orderStatusList.map(item => Number(item))
            if(data.excuteStatusList && data.excuteStatusList.length>0)data.excuteStatusList =data.excuteStatusList.map(item => Number(item))
            data.customerOrderNoList=data.batchQueryValue

        },
        deleteNullSearchParams(searchParams,props) {
            for (const key in searchParams) {
                if (!searchParams[key]) {
                    delete searchParams[key];
                }
            }
            if(props.length){
                for(let i=0;i<props.length;i++){
                    delete searchParams[props[i]];// 删除不需要的参数
                }
            }
        },
        rowDBclick(row) {
            // 表格内双击事件
        },
        checkBtn(data) {
            // 表格内按钮查看事件;
            this.visible = true;
        },
        editBtn(data) {
            // 表格内按钮修改事件;
            this.$refs.editDialog.show(data);
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectedRows = data;
        },
        switchChange(data) {
            // 表格内switch切换事件
        },
        searchListChange(config, data) {
            if (config.selectConfig && config.selectConfig.option) {
                data = data.replace(/\s+/g, ',');
                const obj = {};
                obj[config.value] = data;
                this.$nextTick(() => {
                    const searchList = this.$refs.tablePage.$refs.searchList;
                    searchList.searchData[config.value] = data;
                    if (config.select && searchList.$refs.searchSet) {
                        const searchSet = searchList.$refs.searchSet[0];
                        searchSet.searchList[1].data[config.value] = data;
                    }
                });
            }
            this.searchParams[config.value] = data || '';
        },
        searchChange(data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-search-method');
            // 提交搜索框
            this.searchParams = { ...data, pageSize: this.searchParams.pageSize, pageNo: 1 };
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.getList();
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addRow();
        },
        saveData(data) {
        },
        getTableConfigList(data) { },
        refresh() {
            // 表格内刷新按钮
        },

        adddatail() {
            this.$refs.transTable.showDialog();
        },
        getUploadResult(flag) {
            if (flag) {
                this.getList();
            }
        },
        dialogCheck() {},
        // 导出
        exportFile(submit) {
            // 列表数据为空导出时处理
            const tableLength = this.totalData.length;
            if (!tableLength) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
            submit({ ...this.exportParams, tenantCode: this.currentTenant.tenantCode });
        }
    },
    computed: {
        ...mapState(['user', 'currentTenant'])
    },
    created() {
    }
};
